export const ConsumerAssetSubtypeViewStyles = {
    container: 'flex flex-col w-full items-center',
    title: 'text-blue700 text-16px font-bold text-center sm:text-24px sm:font-semibold',
    subtitle: 'text-blue300 text-16px mt-4 mb-8 font-bold text-center sm:text-20px sm:font-normal',
    assetSubtypeSelector: 'mt-3 mb-8 w-full flex items-center sm:w-328',
    assetSubtypeField: 'w-full',
    buttonContainer: 'text-xl sm:text-2xl'
}